import React from "react";
import "../../css/sharedStyles.css";
import ComicDetail from "../comicDetail/ComicDetail.js";
import ComicDetailDesktop from "../comicDetail/ComicDetailDesktop.js";
import ComicDetailCharacters from "../comicDetail/ComicDetailCharacters.js";


var VideoDetailLayout = class VideoDetailLayout extends React.Component{
    
    componentWillMount(){
      
    }//end componentDidMount() 


    render() {


      return (
          
        <div>

        im the detail page



        </div>
      );
    }
  }

  export default VideoDetailLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/videoDetailLayout.js